import { NavLink } from "react-router-dom";
import { FlaskConical, Radio, ArrowLeftRight } from "lucide-react";
import { cn } from "@/lib/utils";

function Tab({
  to,
  icon: Icon,
  label,
  end,
  badge,
}: {
  to: string;
  icon: React.ComponentType<{ size?: number; className?: string }>;
  label: string;
  end?: boolean;
  badge?: string | null;
}) {
  return (
    <NavLink
      to={to}
      end={end}
      title={label}
      className={({ isActive }) =>
        cn(
          "flex min-h-12 min-w-0 flex-1 flex-col items-center justify-center gap-1 rounded-lg px-1 py-1.5 no-underline transition-colors",
          isActive
            ? "tint-primary"
            : "text-[var(--text-secondary)] hover:bg-[var(--bg-hover)] hover:text-[var(--text-primary)]"
        )
      }
    >
      <span className="relative">
        <Icon size={22} className="shrink-0" />
        {badge && (
          <span className="absolute -right-2 -top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-[var(--primary)] px-1 text-[9px] font-semibold leading-none text-white">
            {badge}
          </span>
        )}
      </span>
      <span className="text-[11px] leading-none font-medium">{label}</span>
    </NavLink>
  );
}

/**
 * Mobile-only bottom navigation bar (Material-style). Same destinations as the
 * top bar's menu on md+: the logo leads to the dashboard and Trades sits by the search.
 */
export default function BottomNav() {
  return (
    <nav
      aria-label="Primary"
      className="flex shrink-0 items-stretch gap-1 border-t border-[var(--border)] bg-[var(--bg-secondary)] px-1 pt-1 pl-[max(0.5rem,env(safe-area-inset-left))] pr-[max(0.5rem,env(safe-area-inset-right))] pb-[env(safe-area-inset-bottom)] md:hidden"
    >
      <Tab to="/lab/backtest" icon={FlaskConical} label="Backtests" />
      <Tab to="/live" icon={Radio} label="Live" />
      <Tab to="/integrations/marketplaces" icon={ArrowLeftRight} label="Accounts" />
    </nav>
  );
}